import { render } from "./LanguageChange.vue?vue&type=template&id=4b9751e3"
import script from "./LanguageChange.vue?vue&type=script&lang=js"
export * from "./LanguageChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__